import {useCallback} from 'react';

import {ONBOARDING_HOME_ADDRESS_EVENTS} from '@/app/auth/events/OnboardingHomeAddressEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackViewOnboardingHomeAddress = useCallback(() => {
    trackEvent(
      ONBOARDING_HOME_ADDRESS_EVENTS.VIEW_ONBOARDING_HOME_ADDRESS,
      {
        project_tag: PROJECT_TAGS.ONBOARDING,
      },
      null,
      false,
    );
  }, [trackEvent]);

  const trackSelectOnboardingSearchHomeAddress = useCallback(() => {
    trackEvent(
      ONBOARDING_HOME_ADDRESS_EVENTS.SELECT_ONBOARDING_SEARCH_HOME_ADDRESS,
      {
        project_tag: PROJECT_TAGS.ONBOARDING,
      },
    );
  }, [trackEvent]);

  const trackSelectOnboardingHomeAddressContinue = useCallback(
    (fieldsChanged: string[]) => {
      trackEvent(
        ONBOARDING_HOME_ADDRESS_EVENTS.SELECT_ONBOARDING_HOME_ADDRESS_CONTINUE,
        {
          project_tag: PROJECT_TAGS.ONBOARDING,
          user: {
            custom_address: {
              fields_changed: fieldsChanged,
            },
          },
        },
      );
    },
    [trackEvent],
  );

  const trackSelectOnboardingHomeConfirmAddressModalEdit = useCallback(() => {
    trackEvent(
      ONBOARDING_HOME_ADDRESS_EVENTS.SELECT_ONBOARDING_HOME_CONFIRM_ADDRESS_MODAL_EDIT,
      {
        project_tag: PROJECT_TAGS.ONBOARDING,
      },
    );
  }, [trackEvent]);

  const trackSelectOnboardingHomeConfirmAddressModalContinue = useCallback(
    (fieldsChanged: string[]) => {
      trackEvent(
        ONBOARDING_HOME_ADDRESS_EVENTS.SELECT_ONBOARDING_HOME_CONFIRM_ADDRESS_MODAL_CONTINUE,
        {
          project_tag: PROJECT_TAGS.ONBOARDING,
          user: {
            custom_address: {
              fields_changed: fieldsChanged,
            },
          },
        },
      );
    },
    [trackEvent],
  );

  const trackViewOnboardingHomeAddressPoBox = useCallback(
    (fieldsChanged: string[]) => {
      trackEvent(
        ONBOARDING_HOME_ADDRESS_EVENTS.VIEW_ONBOARDING_HOME_ADDRESS_POBOX_WARNING,
        {
          project_tag: PROJECT_TAGS.ONBOARDING,
          user: {
            custom_address: {
              fields_changed: fieldsChanged,
            },
          },
        },
      );
    },
    [trackEvent],
  );

  return {
    trackViewOnboardingHomeAddress,
    trackSelectOnboardingSearchHomeAddress,
    trackSelectOnboardingHomeAddressContinue,
    trackSelectOnboardingHomeConfirmAddressModalEdit,
    trackSelectOnboardingHomeConfirmAddressModalContinue,
    trackViewOnboardingHomeAddressPoBox,
  };
};
